import { render, staticRenderFns } from "./deviceadd.vue?vue&type=template&id=4368e2c1&"
import script from "./deviceadd.vue?vue&type=script&lang=js&"
export * from "./deviceadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports